angular.module('rightPaneModule')
  .directive('pdodProgress', [function() {
    return {
      restrict: "E",
      scope: {
        teacherToolMode: '@',
        value: '@'
      },
      templateUrl: '/resources/right-pane/partials/pdod-progress.html',
      link: function(scope, element, attrs) {
       scope.teacherToolMode = attrs.teacherToolMode === 'true';
      } // end of link
    };
  }]);
